import { type PageList } from '@cplug/frontend-core/models'
import { Result } from '@cplug/frontend-core/utils'
import { type LegalTerm } from '../models/LegalTerm'
import { mapDTOToLegalTerm, mapLegalTermToDTO, LegalTermDTO } from './DTOs/LegalTermDTO'
import { CPBaseCRUDGateway } from '~/shared/gateways/CPBaseCRUDGateway'

type ListDTO = { legal_terms: LegalTermDTO[] }

export class CPLegalTermGateway extends CPBaseCRUDGateway<LegalTermDTO, ListDTO, LegalTerm> {
  protected apiUrlDomain = 'legal-terms'

  protected dtoToModelMapper = (dto: LegalTermDTO): Result<LegalTerm> => Result.ofValue(mapDTOToLegalTerm(dto))
  protected modelToDtoMapper = mapLegalTermToDTO
  protected dtoSchema = LegalTermDTO

  protected get listField (): 'legal_terms' {
    return 'legal_terms'
  }

  protected override get modelIdField (): keyof LegalTerm {
    return 'id'
  }

  /**
   * ERP legal terms are versioned via POST (CreateStoreLegalTermUseCase) — there is no PUT route.
   */
  override edit (model: LegalTerm): Promise<Result<LegalTerm>> {
    return this.create(model)
  }

  async listByApp (appId: number): Promise<Result<PageList<LegalTerm>>> {
    const response = await this.get<{ data: ListDTO; meta: { total: number } }>(`${this.apiUrlDomain}/apps/${appId}`)

    return this.parseResponse(response, this.listResponseDtoSchema, this.listDtoToModelPageListMapper.bind(this))
  }
}
